import React, { useEffect, useState } from 'react';

const InstalledMessage = () => {
  const [messageText, setMessageText] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  async function getMessageTextFromBucket(url) {
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'text/plain',
        },
      });
      const data = await response.text();
      setMessageText(data || '');
    } catch (error) {
      setMessageText('Unable to load installation instructions right now.');
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getMessageTextFromBucket('https://portal-help-items.s3-us-west-2.amazonaws.com/InstalledInstallMessage.txt');
  }, []);

  return (
    <div
      id="messageDiv"
      style={{ marginLeft: '50px', marginRight: '50px', marginBottom: '50px', lineHeight: 1.6, textAlign: 'center' }}
    >
      <div style={{ whiteSpace: 'pre-wrap' }}>
        {isLoading ? 'Loading...' : messageText}
      </div>
    </div>
  );
};
export default InstalledMessage;
